import React from "react";
import PropTypes from "prop-types";
import { withTheme } from "@material-ui/core/styles";
import useMediaQuery from "../../../../hooks/useMediaQuery";

export function VehicleDataWidgetActionButtons(props) {
  const isMobile = useMediaQuery(props.theme.breakpoints.down("sm"));

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width: "calc(100% - 32px)",
        margin: "25px auto",
        height: isMobile ? 40 : 76,
      }}
    >
      {props.children}
    </div>
  );
}

VehicleDataWidgetActionButtons.propTypes = {
  children: PropTypes.any.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withTheme(VehicleDataWidgetActionButtons);
